import script from "./ExternalLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExternalLink.vue?vue&type=script&setup=true&lang=ts"

import "./ExternalLink.vue?vue&type=style&index=0&id=4f9c2602&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/blueshift-vesting-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f9c2602"]])

export default __exports__